import {ApplicationRef, ComponentRef, EmbeddedViewRef, EventEmitter, Injectable, Type, createComponent} from '@angular/core';
import {NgEventBus} from 'ng-event-bus';
import {AttachmentModel} from '../../models/attachment-model';
import {FirmLogoModel} from '../../models/firm-logo.model';

export interface ModalComponent {
    modalClosed: EventEmitter<string | AttachmentModel | FirmLogoModel | boolean | never>;
}

@Injectable({
    providedIn: 'root'
})
export abstract class ModalService {
    modalComponentRef: ComponentRef<ModalComponent>;
    modalOpen: boolean;

    constructor(
        protected appRef: ApplicationRef,
        private eventBus: NgEventBus
    ) {}

    protected createModalComponent(component: Type<ModalComponent>) {
        if (!this.modalComponentRef) {
            this.modalComponentRef = createComponent(component, {
                environmentInjector: this.appRef.injector
            });

            // attach view to make it part of change detection cycle
            this.appRef.attachView(this.modalComponentRef.hostView);

            // listen to Output events
            const ref = this.modalComponentRef.instance.modalClosed.subscribe(data => {
                console.log('Listen to ', data);
                // remove element, then unsubscribe
                this.appRef.detachView(this.modalComponentRef.hostView);
                this.modalComponentRef.destroy();
                ref.unsubscribe();
                // document.body.style.overflow = 'auto';
                this.modalOpen = false;
                this.modalComponentRef = undefined;
                this.eventBus.cast('modal::closed');
            });
        }
    }

    protected showModalComponent() {
        this.eventBus.cast('modal::open');

        document.body.prepend((<EmbeddedViewRef<ModalComponent>>this.modalComponentRef.hostView).rootNodes[0]);
        // document.body.style.overflow = 'hidden';
        this.modalOpen = true;
    }
}
